/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * Which of the two separately scheduled checks this is
 */
export enum EmergencyLightCheckKind {
  FLICK_TEST = "FLICK_TEST",
  VISUAL_CHECK = "VISUAL_CHECK",
}
